<ng-template #shapeTemplate>
    <svg:rect attr.id="{{shape.shapeProperties.name}}" class="draggable" attr.x="{{ shape.originX }}" rx="10px" ry="10px" attr.y="{{ shape.originY }}" attr.width="{{ shape.width }}" attr.height="{{ shape.height }}" [ngStyle]="setStyles()">
        <title>{{ shape.shapeProperties.name }}</title>
    </svg:rect>
</ng-template>